import { Portal } from "@ariakit/react";
import { List } from "@phosphor-icons/react";
import {
  Button,
  Disclosure,
  DisclosureContent,
  DisclosureProvider,
} from "@replicate/ui";
import { route } from "../../urls";

export default function MobileMenu({
  isAuthenticated,
}: {
  isAuthenticated: boolean;
}) {
  const portalElement = document.getElementById("js-mobile-menu");

  const links = [
    {
      label: "Explore",
      href: route("explore"),
      type: "link",
    },
    {
      label: "Pricing",
      href: route("pricing"),
      type: "link",
    },
    {
      label: "Docs",
      href: route("docs"),
      type: "link",
    },
    {
      label: "Blog",
      href: route("blog_index"),
      type: "link",
    },
    {
      label: "Changelog",
      href: route("changelog_list"),
      type: "link",
    },
  ];

  if (isAuthenticated) {
    links.unshift({
      label: "Dashboard",
      href: route("home"),
      type: "cta",
    });
  } else {
    links.push({
      label: "Sign in",
      href: route("signin"),
      type: "cta",
    });
  }

  return (
    <DisclosureProvider>
      <Disclosure
        render={<Button size="sm" variant="outlined" startIcon={<List />} />}
      >
        Menu
      </Disclosure>
      <Portal portalElement={portalElement}>
        <DisclosureContent className="px-6 bg-r8-gray-1 border-b border-r8-gray-6">
          <nav className="flex flex-col divide-y divide-r8-gray-4 py-2">
            {links.map((link) => (
              <a
                className={
                  link.type === "cta"
                    ? "bg-r8-gray-12 text-r8-gray-1 px-2 py-2.5 text-center no-focus"
                    : "block no-default no-focus px-2 py-2.5 no-underline text-r8-gray-11 hover:text-r8-gray-12 text-r8-sm"
                }
                key={link.label}
                href={link.href}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </DisclosureContent>
      </Portal>
    </DisclosureProvider>
  );
}
